import { Component, OnInit } from '@angular/core';
import {  LoginUser } from './_models';
import { BehaviorSubject, Observable } from 'rxjs';
import { GlobalDataService } from './_shared';
import { UserService, ReportService } from './_services';
import { CalAngularService } from '@cvx/cal-angular';
import { DataService } from './_services/data_service';
import { environment } from '../environments/environment';
import { IdleTimerService } from './_services/idle-timer.service';
import { MatDialog } from '@angular/material/dialog';
import { SessionRefreshDialogComponent } from './_shared/session-refresh-dialog/session-refresh-dialog.component';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: false
})
export class AppComponent implements OnInit {
  title = 'ChevronAmsUI';
  loading = false;
  submitted = false;
  returnUrl!: string;
  error = '';
   currentUser!: LoginUser[];
  private currentUserSubject!: BehaviorSubject<LoginUser | null>;
  authData!: Observable<Object>;
  loggedIn: boolean = false;
  userProperty: any;

  constructor(
    private idleTimer: IdleTimerService,
    private dialog: MatDialog,
    private gd : GlobalDataService,
    private userService: UserService,
    private reportService: ReportService,
    private authService: CalAngularService,
    private dataService: DataService
  ) {
  }
 
   
  getSuppliers()
  {
    this.reportService.getSuppliers().subscribe(data=>{
      if(data!=null ) 
       this.gd.setSupplierData(data)
    });
  }
 

  getCostCenterList()
  {
    this.userService.getCostCenterList().subscribe(data=>{
      if(data!=null ) 
       this.gd.setCostCenterData(data)
    });
  }
  
  getObjectAccount()
  {
    this.reportService.getObjectAcunt().subscribe(data=>{
      if(data!=null ) 
      this.gd.setAccountData(data)
    });
  }

  logout() {
      // remove user from local storage to log user out
      localStorage.removeItem('currentUser');
      this.currentUserSubject.next(null);
  }
  
  async ngOnInit() {
    this.idleTimer.startIdleWatch(10); // 10 minutes
    this.idleTimer.onIdle().subscribe(() => {
       if (this.dialog.openDialogs.length === 0) {
          const dialogRef = this.dialog.open(SessionRefreshDialogComponent);
          dialogRef.componentInstance.displayModal = true;
          dialogRef.componentInstance.onContinue.subscribe((data) => {
            if (data.isContinue) {
              this.dialog.closeAll();
            }
          });
       }
    });
    
    this.loggedIn = false;
    await this.logIn();
   
  }

  async logIn() {

    this.authService.userInitiatedSignIn().subscribe(async (user: any) => {
      if (this.authService.isUserSignedIn()) {
        this.userProperty  = this.authService.cvxClaimsPrincipal;
        this.getToken();
        this.loggedIn = true;
      }
      else {
        this.loggedIn = false;
      }
    
    });
  }

  // to get logged-in user details
  async currentUserDetails(): Promise<LoginUser[]> {
    const result = await new Promise<boolean>((resolve) => {
      this.currentUser = [];
 
      this.authService
        .getUserPropertiesFromMsGraph([
          'displayName',
          'cai',
          'jobTitle',
          'surname',
          'mail',
          'Id',
          'provisioningId',
          'CAI'
        ])
        .subscribe((graphProp) => {
          if (graphProp) {
            this.currentUser.push({
              Name: graphProp['displayName'],
              Email: graphProp['mail'],
              Employee_Number: 0,
              Cost_Center: '',
              Department: '',
              Position: graphProp['jobTitle'],
              Work_Location: '',
              Employee_CAI: graphProp['cai'],
              Supervisor_Name: '',
              YAP001: '',
              Role: '',
              ProvisioningID: ''
            });
            resolve(true);
          } else {
            resolve(false);
          }
        });
    });

    switch (result) {
      case true: {
        this.loggedIn = true;
        this.dataService.getUserDetail(this.currentUser);
        return this.currentUser;
      }
      case false: {
        this.loggedIn = false;
        return [];
      }
    }
  }

  getToken() {
   const oidcScopes: string[] = environment.calConfig.scopes;
    this.authService.getAADToken(oidcScopes,true).subscribe((token:any) => {
      if (token) {
        localStorage.setItem('access-token', JSON.parse(JSON.stringify(token.accessToken)));
        
      }
    });
  }
  

}
